<template>
  <div
    class="product w-100 pb20 mb20"
    v-observe-visibility="visibilityChanged"
  >
    <div
      class="block no-underline product-link"
      @click="clickToClose"
    >
      <router-link
        :to="productLink"
        data-testid="productLink"
        class="no-underline"
      >
        <div
          class="product-image relative"
          :class="[{ sale: labelsActive && isOnSale }, { new: labelsActive && isNew }]"
        >
          <product-image
            class="product-image__content"
            :image="thumbnailObj"
            :alt="product.name | htmlDecode"
            data-testid="productImage"
          />
        </div>
        <div class="px20-md">
          <price :product="product" :qty="1" />
        </div>
        <p class="mb0 cl-accent px20-md" v-if="!onlyImage">
          {{ product.name | htmlDecode }}
        </p>

      </router-link>
    </div>
    <mini-add-to-cart-custom-option v-if="product.custom_options && product.custom_options.length > 0
      && product.custom_options.filter(option => option.is_active === 1).length && isCheckoutAllowed && activeButtonAddToCart"
        :product="singleOptionProduct ? singleOptionProduct : product"
        class="list-button h5 center-xs product-tile-button"
       :categoryId="categoryId"
    />
    <mini-add-to-cart v-else-if="isCheckoutAllowed && activeButtonAddToCart" class="col-xs-12 col-sm-4 col-md-6 product-tile-button" :product="product"/>
  </div>
</template>

<script>
import rootStore from '@vue-storefront/core/store'
import { ProductTile } from '@vue-storefront/core/modules/catalog/components/ProductTile.ts'
import config from 'config'
import ProductImage from './ProductImage'
import MiniAddToCart from './MiniAddToCart';
import MiniOpenConfigurator from './MiniOpenConfigurator'
import AddToCart from 'theme/components/core/AddToCart'
import { mapMutations, mapGetters } from 'vuex'
import * as types from '@vue-storefront/core/modules/catalog/store/product/mutation-types'
import MiniAddToCartCustomOption from './MiniAddToCartCustomOption';
import Price from 'theme/components/core/blocks/Product/Price'

function _defaultOptionValue (co) {
  switch (co.type) {
    case 'select': return co.values && co.values.length ? co.values[0].option_type_id : 0
    case 'radio': return co.values && co.values.length ? co.values[0].option_type_id : 0
    case 'checkbox':
      if (co.is_require) {
        return co.values && co.values.length ? co.values[0].option_type_id : 0
      }
      return false
    default: return ''
  }
}

function _fieldName (co) {
  return 'customOption_' + co.option_id
}

export default {
  mixins: [ProductTile],
  components: {
    ProductImage,
    MiniAddToCart,
    MiniOpenConfigurator,
    AddToCart,
    MiniAddToCartCustomOption,
    Price
  },
  data () {
    return {
      isActiveDesc: false,
      flagDescriptions : false,
      singleOptionProduct: null
    }
  },
  mounted () {
    if(this.$refs.descriptions !== undefined) {
      this.flagDescriptions = this.$refs.descriptions.offsetHeight >= 170;
    }
    this.$bus.$on('product-after-customoptions', this.onAfterCustomOptionsChanged)
    if (this.product.custom_options && this.product.custom_options.length === 1 && this.product.custom_options.filter(option => option.is_active === 1).length) {
      this.singleOptionProduct = this.product
      this.setupInputFields()
    }
  },
  props: {
    labelsActive: {
      type: Boolean,
      default: true
    },
    onlyImage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    thumbnailObj () {
      let imageLink = this.thumbnail
      if (!(this.thumbnail.match(/\.jpeg|JPEG|jpg|JPG|gif|GIF|png|PNG/)) && this.product &&
        this.product.hasOwnProperty('additional_images') && this.product.additional_images) {
        imageLink = this.product.additional_images.product_thumbnail
          ? this.product.additional_images.product_thumbnail
          .replace('http://service.korzyna.com/pub/media/catalog', '')
          .replace('https://service.korzyna.com/pub/media/catalog', '')
          : this.placeholder
      }
      return {
        src: imageLink,
        loading: this.thumbnail
      }
    },
    cartItem () {
      return this.$store.getters['cart/getCartItems'].find(item => item.entity_id === this.product.entity_id)
    },
    activeButtonAddToCart () {
      return this.currentPartner.active && this.currentPartner.enabled
    },
    qtyInCart () {
      if (this.cartItem) {
        return this.cartItem.qty
      }
    },
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      currentPartner: 'partners/getCurrentPartner'
    }),
    isCheckoutAllowed () {
      return (this.currentLocation.hasOwnProperty('is_checkout_allowed')) ? this.currentLocation.is_checkout_allowed : true
    }
  },
  methods: {
    onProductPriceUpdate (product) {
      if (product.sku === this.product.sku) {
        Object.assign(this.product, product)
      }
    },
    visibilityChanged (isVisible, entry) {
      if (isVisible) {
        if (config.products.configurableChildrenStockPrefetchDynamic && rootStore.products.filterUnavailableVariants) {
          const skus = [this.product.sku]
          if (this.product.type_id === 'configurable' && this.product.configurable_children && this.product.configurable_children.length > 0) {
            for (const confChild of this.product.configurable_children) {
              const cachedItem = rootStore.state.stock.cache[confChild.id]
              if (typeof cachedItem === 'undefined' || cachedItem === null) {
                skus.push(confChild.sku)
              }
            }
            if (skus.length > 0) {
              rootStore.dispatch('stock/list', { skus: skus }) // store it in the cache
            }
          }
        }
      }
    },
    onAfterCustomOptionsChanged (payload) {
      let priceDelta = 0
      let priceDeltaInclTax = 0
      let optionsToProduct = []
      for (const optionValue of Object.values(payload.optionValues)) {
        optionsToProduct.push(optionValue)
        if (typeof optionValue === 'object' && parseInt(optionValue.option_type_id) > 0) {
          if (optionValue.price_type === 'fixed' && optionValue.price !== 0) {
            priceDelta += optionValue.price
            priceDeltaInclTax += optionValue.price
          }
          if (optionValue.price_type === 'percent' && optionValue.price !== 0) {
            priceDelta += ((optionValue.price / 100) * product.price)
            priceDeltaInclTax += ((optionValue.price / 100) * product.priceInclTax)
          }
        }
      }

      this.singleOptionProduct = Object.assign({}, this.product, { selected_options: optionsToProduct })
      this.singleOptionProduct.price = this.product.price + priceDelta
      this.singleOptionProduct.originalPriceInclTax = this.product.priceInclTax + priceDeltaInclTax
      this.singleOptionProduct.regular_price = this.product.priceInclTax + priceDeltaInclTax
      this.singleOptionProduct.priceInclTax = this.product.priceInclTax + priceDeltaInclTax
    },
    setupInputFields () {
      let co = this.product.custom_options[0]
      this.optionChanged(co, co.values[0])
    },
    optionChanged (option, opval) {
      const fieldName = _fieldName(option)
      const value = opval.option_type_id
      this.setCustomOptionValue({ optionId: option.option_id, optionValue: value })
      this.$store.dispatch('product/setCustomOptions', {
        product: this.product,
        customOptions: this.$store.state.product.current_custom_options
      })
      let optionValues = {}
      optionValues[fieldName] = opval
      this.onAfterCustomOptionsChanged({ product: this.product, option: option, optionValues })
    },
    ...mapMutations('product', {
      setCustomOptionValue: types.CATALOG_UPD_CUSTOM_OPTION // map `this.add()` to `this.$store.commit('increment')`
    }),
  },
  beforeMount () {
    this.$bus.$on('product-after-priceupdate', this.onProductPriceUpdate)
  },
  beforeDestroy () {
    this.$bus.$off('product-after-priceupdate', this.onProductPriceUpdate)
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/animations/transitions';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

$bg-secondary: color(secondary, $colors-background);
$border-secondary: color(secondary, $colors-border);
$color-white: color(white);
.px20-md {
  padding-left: 20px;
  padding-right: 20px;
  @media (max-width: 500px) {
    padding-left: 0;
    padding-right: 0;
  }
}

.product {
  background: #FFFFFF;
  overflow: hidden;
  @media (max-width: 768px) {
    padding-bottom: 10px;
  }
}

.price-original {
  text-decoration: line-through;
}
.black{
    color: #000;
}
%label {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: $border-secondary;
  text-transform: uppercase;
  color: $color-white;
  font-size: 12px;
}

.product-image{
  width:100%;
  height: 100%;
  max-height: 300px;

  &:hover{
    .product-image__content{
      opacity: 1;
      transform: scale(1.1);
    }
    &.sale::after,
    &.new::after{
      opacity: .8;
    }
  }
  &__content{

    padding-bottom: calc(300% / (257 / 100));
    mix-blend-mode: darken;
    transform: scale(1);
    will-change: transform;
    transition: .3s opacity $motion-main, .3s transform $motion-main;
    @media (min-width: 769px) {
      padding-bottom: calc(208% / (168 / 100));
    }
    @media (min-width: 1200px) {
      padding-bottom: calc(300% / (276 / 100));
    }
  }

  &.sale{
    &::after {
      @extend %label;
      content: 'Sale';
    }
  }
  &.new{
    &::after {
      @extend %label;
      content: 'New';
    }
  }
}
</style>
<style lang="scss">
 .product-tile-button{
   top: 10px!important;
   right: 15px!important;
   @media (max-width: 500px) {
     top: 7px!important;
     right: 5px!important;
   }
 }
</style>
